import styled from '@emotion/styled';

export const Wrapper = styled.div`
svg{
    font-size: 20px;
    color: #ffb300;
    fill: #ffb300;

  @media screen and (min-width: 768px) {
    font-size: 24px;

  }
}
`;